import { motion, AnimatePresence } from "framer-motion";
import { Button } from "./ui/button";

const CONFETTI = ["#FF5A79", "#FFC02D", "#2AB7CA", "#2EC4B6", "#9B5DE5"];

export default function StickerReward({ sticker, onClose }) {
  return (
    <AnimatePresence>
      {sticker && (
        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[120] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4"
          data-testid="sticker-reward" onClick={onClose}>
          {/* confetti */}
          {Array.from({ length: 18 }).map((_, i) => (
            <motion.span key={i}
              className="absolute top-1/3 h-2.5 w-2.5 rounded-full"
              style={{ backgroundColor: CONFETTI[i % CONFETTI.length], left: `${8 + (i * 5) % 85}%` }}
              initial={{ y: -20, opacity: 1 }}
              animate={{ y: 400, opacity: 0, rotate: 360 }}
              transition={{ duration: 1.6 + (i % 4) * 0.3, repeat: Infinity, delay: (i % 6) * 0.1 }} />
          ))}
          <motion.div
            initial={{ scale: 0.4, y: 40 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.6, opacity: 0 }}
            transition={{ type: "spring", damping: 12 }}
            className="relative bg-white rounded-3xl shadow-2xl p-10 text-center max-w-sm w-full"
            onClick={(e) => e.stopPropagation()}>
            <div className="text-xs uppercase tracking-widest font-bold text-[#2AB7CA] mb-2">New Sticker Unlocked!</div>
            <motion.div animate={{ rotate: [0, -8, 8, 0] }} transition={{ repeat: Infinity, duration: 2 }}
              className="text-7xl mb-3">{sticker.emoji}</motion.div>
            <h3 className="text-2xl font-display font-bold text-slate-900">{sticker.name}</h3>
            <p className="text-slate-500 mt-1">{sticker.reason}</p>
            <Button data-testid="claim-sticker-btn" onClick={onClose}
              className="mt-6 rounded-full bg-[#FF5A79] hover:bg-[#e04865] font-bold px-8 h-12">Awesome! 🎉</Button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
